import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { locationServices, seafreightratesServices } from '../../../Services'
import { Loader } from '../../../Components'

export const EditSeaFreightRate = () => {
    const history = useHistory()
    const data = history.location.state

    const [countryList, setCountryList] = useState([])
    const [destinationCountryValue, setDestinationCountryValue] = useState({ label: data.destination_country_name, value: data.destination_country_id })
    const [originCountryValue, setOriginCountryValue] = useState({ label: data.origin_country_name, value: data.origin_country_id })
    const [originCityValue, setOriginCityValue] = useState({ label: data.origin_city_name, value: data.origin_city_id })
    const [destinationCityValue, setDestinationCityValue] = useState({ label: data.destination_city_name, value: data.destination_city_id })
    const [originCityList, setOriginCityList] = useState([])
    const [destinationCityList, setDestinationCityList] = useState([])
    const [loader, setLoader] = useState(true)
    const formik = useFormik({
        initialValues: {
            origin_country_id: data.origin_country_id,
            destination_country_id: data.destination_country_id,
            origin_city_id: data.origin_city_id,
            destination_city_id: data.destination_city_id,
            minimum_amount: data.minimum_amount,
            additional_fee: data.additional_fee,
            rate_per_cmb: data.rate_per_cmb,
            port_delivery_tt: data.port_delivery_tt,
            door_delivery_tt: data.door_delivery_tt,
            seafreightrats_id: data._id
        },
        validationSchema: Yup.object({
            origin_country_id: Yup.string().required('Required'),
            destination_country_id: Yup.string().required('Required'),
            origin_city_id: Yup.string().required('Required'),
            destination_city_id: Yup.string().required('Required'),
            minimum_amount: Yup.string().required('Required'),
            port_delivery_tt: Yup.string().required('Required'),
            door_delivery_tt: Yup.string().required('Required'),
            rate_per_cmb: Yup.string().required('Required'),
            additional_fee: Yup.string().required('Required')
        }),
        onSubmit: values => {
            setLoader(true)
            let postData = {
                ...values,
            }
            seafreightratesServices.updateSeafreightrates(postData).then(res => {
                console.log(res, "sea")
                if (res.status) {
                    setLoader(false)
                    history.push('/sea-freight-rate-list')
                } else {
                    setLoader(false)
                    toast.error(res.message)
                }
            })
        },
    });

    useEffect(() => {
        getCountryList()
    }, [])

    const getCityList = (id, act) => {
        let param = {
            country_id: id.value
        }
        locationServices.getCity(param).then((res) => {
            if (res.status) {
                let arry = []
                res.data.map(list => {
                    arry.push({ value: list._id, label: list.city_name, data: list })
                })
                switch (act) {
                    case 'destination':
                        setDestinationCityList(arry)
                        setDestinationCityValue('')
                        break;
                    case 'origin':
                        setOriginCityList(arry)
                        // let activeCity = arry.filter(item => item.data.city_name === 'Dubai')
                        // if (activeCity.length) {
                        //     setOriginCityValue(activeCity[0])
                        //     formik.setValues({
                        //         ...formik.values,
                        //         origin_country_id: id.value,
                        //         origin_city_id: activeCity[0].value
                        //     })
                        // } else {
                        //     formik.setValues({
                        //         ...formik.values,
                        //         origin_country_id: id.value,
                        //         origin_city_id: ''
                        //     })
                        //     setOriginCityValue('')
                        // }
                        break;
                }
                setLoader(false)
            }
        })
    }

    const getCountryList = () => {
        locationServices.getCountry().then(res => {
            if (res.status) {
                let arry = []
                res.data.map(list => {
                    arry.push({ value: list._id, label: list.country_name, data: list })
                })

                let activeCountry = arry.filter(item => item.data.country_currency === 'AED')
                if (activeCountry.length) {
                    onSelectCountry(activeCountry[0], 'origin')
                }

                setCountryList(arry)

            } else {
                toast.error(res.message)
            }
        })
    }

    const onSelectCountry = (e, act) => {
        switch (act) {
            case 'origin':
                getCityList(e, act)
                setOriginCountryValue(e)

                break;
            case 'destination':
                getCityList(e, act)
                setDestinationCountryValue(e)
                formik.setValues({
                    ...formik.values,
                    destination_country_id: e.value,
                    destination_city_id: '',
                })

                break;
        }
    }

    const onSelectCity = (e, act) => {
        let arry1 = originCityList
        let arry2 = destinationCityList
        let newArry1 = []
        let newArry2 = []
        arry1.map(list => {
            newArry1.push({ ...list, isdisabled: list.value === e.value })
        })
        arry2.map(list => {
            newArry2.push({ ...list, isdisabled: list.value === e.value })
        })
        setOriginCityList(newArry1)
        setDestinationCityList(newArry2)
        switch (act) {
            case 'origin':
                setOriginCityValue(e)
                formik.setValues({ ...formik.values, origin_city_id: e.value })

                break;
            case 'destination':
                setDestinationCityValue(e)
                formik.setValues({ ...formik.values, destination_city_id: e.value })

                break;
        }
    }

    return (
        <div className="row d-flex justify-content-center">
            <div className="col-lg-8">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                            <div className="row">
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label" >Origin country </label>
                                    </div>
                                    <div className="col-9">
                                        <Select
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: 'calc(2.15rem + 2px)',
                                                    overflowY: 'visible'
                                                }),
                                                control: (provider) => ({
                                                    ...provider,
                                                    borderColor: formik.touched.origin_country_id ? !formik.errors.origin_country_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                    boxShadow: '0 0 0 0px #f46a6a'
                                                }),
                                                placeholder: (provider) => ({
                                                    ...provider,
                                                    color: '#a0b0ca'
                                                })
                                            }}
                                            value={originCountryValue}
                                            onChange={(e) => onSelectCountry(e, 'origin')}
                                            options={countryList}
                                        />
                                        {formik.touched.origin_country_id && formik.errors.origin_country_id ? (
                                            <div className="text-danger">{formik.errors.origin_country_id}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label" >Origin city</label>
                                    </div>
                                    <div className="col-9">
                                        <Select
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: 'calc(2.15rem + 2px)',
                                                    overflowY: 'visible'
                                                }),
                                                control: (provider) => ({
                                                    ...provider,
                                                    borderColor: formik.touched.origin_city_id ? !formik.errors.origin_city_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                    boxShadow: '0 0 0 0px #f46a6a'
                                                }),
                                                placeholder: (provider) => ({
                                                    ...provider,
                                                    color: '#a0b0ca'
                                                })
                                            }}
                                            value={originCityValue}
                                            // isOptionDisabled={(option) => option.isdisabled}
                                            onChange={(e) => onSelectCity(e, 'origin')}
                                            options={originCityList}
                                        />
                                        {formik.touched.origin_city_id && formik.errors.origin_city_id ? (
                                            <div className="text-danger">{formik.errors.origin_city_id}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label" >Destination country</label>
                                    </div>
                                    <div className="col-9">
                                        <Select
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: 'calc(2.15rem + 2px)',
                                                    overflowY: 'visible'
                                                }),
                                                control: (provider) => ({
                                                    ...provider,
                                                    borderColor: formik.touched.destination_country_id ? !formik.errors.destination_country_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                    boxShadow: '0 0 0 0px #f46a6a'
                                                }),
                                                placeholder: (provider) => ({
                                                    ...provider,
                                                    color: '#a0b0ca'
                                                })
                                            }}
                                            value={destinationCountryValue}
                                            onChange={(e) => onSelectCountry(e, 'destination')}
                                            options={countryList}
                                        />
                                        {formik.touched.destination_country_id && formik.errors.destination_country_id ? (
                                            <div className="text-danger">{formik.errors.destination_country_id}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label" >Destination city</label>
                                    </div>
                                    <div className="col-9">
                                        <Select
                                            styles={{
                                                valueContainer: (provided) => ({
                                                    ...provided,
                                                    height: 'calc(2.15rem + 2px)',
                                                    overflowY: 'visible'
                                                }),
                                                control: (provider) => ({
                                                    ...provider,
                                                    borderColor: formik.touched.destination_city_id ? !formik.errors.destination_city_id ? '#34c38f' : '#f46a6a' : '#ced4da',
                                                    boxShadow: '0 0 0 0px #f46a6a'
                                                }),
                                                placeholder: (provider) => ({
                                                    ...provider,
                                                    color: '#a0b0ca'
                                                })
                                            }}
                                            value={destinationCityValue}
                                            // isOptionDisabled={(option) => option.isdisabled}
                                            onChange={(e) => onSelectCity(e, 'destination')}
                                            options={destinationCityList}
                                        />
                                        {formik.touched.destination_city_id && formik.errors.destination_city_id ? (
                                            <div className="text-danger">{formik.errors.destination_city_id}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Minimum CBM</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            required={false}
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.minimum_amount ? !formik.errors.minimum_amount ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('minimum_amount')}
                                            placeholder="Enter minimum amount"
                                        />
                                        {formik.touched.minimum_amount && formik.errors.minimum_amount ? (
                                            <div className="text-danger">{formik.errors.minimum_amount}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Additional Fee</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.additional_fee ? !formik.errors.additional_fee ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('additional_fee')}
                                            placeholder="Enter additional fee"
                                        />
                                        {formik.touched.additional_fee && formik.errors.additional_fee ? (
                                            <div className="text-danger">{formik.errors.additional_fee}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Rate Per CMB</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.rate_per_cmb ? !formik.errors.rate_per_cmb ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('rate_per_cmb')}
                                            placeholder="Enter rate per cmb"
                                        />
                                        {formik.touched.rate_per_cmb && formik.errors.rate_per_cmb ? (
                                            <div className="text-danger">{formik.errors.rate_per_cmb}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Port delivery tt</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.port_delivery_tt ? !formik.errors.port_delivery_tt ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('port_delivery_tt')}
                                            placeholder="Enter port delivery tt"
                                        />
                                        {formik.touched.port_delivery_tt && formik.errors.port_delivery_tt ? (
                                            <div className="text-danger">{formik.errors.port_delivery_tt}</div>
                                        ) : null}
                                    </div>
                                </div>
                                <div className="mb-3 row">
                                    <div className="col-3">
                                        <label className="form-label">Door delivery tt</label>
                                    </div>
                                    <div className="col-9">
                                        <input
                                            type="number"
                                            min="0"
                                            className={'form-control' + (formik.touched.door_delivery_tt ? !formik.errors.door_delivery_tt ? ' is-valid' : ' is-invalid' : '')}
                                            {...formik.getFieldProps('door_delivery_tt')}
                                            placeholder="Enter door delivery tt"
                                        />
                                        {formik.touched.door_delivery_tt && formik.errors.door_delivery_tt ? (
                                            <div className="text-danger">{formik.errors.door_delivery_tt}</div>
                                        ) : null}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => formik.handleSubmit()}
                                >Submit</button>
                            </div>
                        </form>
                        {/* <Loader isShow={loader} /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}
